import { createClient as createSupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

let cached = null;

export function isSupabaseConfigured() {
  return Boolean(SUPABASE_URL?.trim() && SUPABASE_ANON_KEY?.trim());
}

export function createClient() {
  if (cached) return cached;

  if (!isSupabaseConfigured()) {
    throw new Error(
      'Missing Supabase configuration. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY (e.g. in .env.local for dev, or in your host build environment for production).',
    );
  }

  cached = createSupabaseClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  });
  return cached;
}
